import { CircularProgress, Grid2 } from "@mui/material";
import BillingStyle from "./BasePlanBillingSummary.module.scss";
import { useEffect, useState } from "react";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import { useStripe } from "@stripe/react-stripe-js";
import { cashfreeSubscriptionSessionIdDecrypt } from "../../../../../../Utils/cashfree";
import CouponCode from "../Coupon/CouponCode";
import RemoveIcon from "@mui/icons-material/Remove";
import NewPopup from "../../../../../../GlobalComponents/Popup/NewPopup";
import ModalPopup from "../../../../../../GlobalComponents/Popup/ModalPopup";
import PaymentStatus from "../PaymentStatus/PaymentStatus";

const BasePlanBillingSummary = (props) => {
  const {
    isPaneOpen,
    billingType,
    matchingBillingData,
    country,
    numSites,
    isSingleSite,
    downgradePopup,
    noUpgradePopup,
    upgradePopup,
    upgradeFailPopup,
    singleSitePopup,
    waitPlanPopup,
    setIsPaneOpen,
    formatIndianCurrency,
    setIsIndPayment,
    flushStateVariables,
    specificPlan,
    orgId,
    isLoading,
    setIsLoading,
    navigate,
    coupon,
    setCoupon,
    isCouponLoading,
    handleClick,
    isData,
    setIsData,
    showInput,
    setShowInput,
    isProcessingCashfree,
    handleIndPayment,
    isProcessing,
  } = props;

  const stripe = useStripe();
  const [showPopup, setShowPopup] = useState(false);
  const isSummaryLoading =
    !isData ||
    Object.keys(isData).length === 0 ||
    isData?.yearlyPrice === undefined ||
    isData?.totalAmount === undefined;

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_ALL_PLANS,
      meta: {
        onSuccess: (data) => {
          let monthPlans = [];
          let yearPlans = [];
          data?.plans?.licenses?.map((license) => {
            if (
              license.licenseType !== "Community Edition Beta" &&
              license.licenseType !== "Custom" &&
              license.licenseType !== "To The Moon"
            ) {
              let monthPlan = {};
              let yearPlan = {};
              monthPlan.name = license.licenseType + " Monthly";
              yearPlan.name = license.licenseType + " Yearly";
              monthPlan.licenseType = license.licenseType;
              yearPlan.licenseType = license.licenseType;
              license.pricing?.map((price) => {
                if (license.isSingleSitePlan === false) {
                  if (price.billingType === "Monthly") {
                    monthPlan.price = `₹${formatIndianCurrency(
                      price.orginalPrice_INR,
                    )} per Month`;
                    monthPlan.priceInDollars = `₹${formatIndianCurrency(
                      price.orginalPrice_INR,
                    )}`;
                    monthPlan.priceId = price.stripePriceId;
                  } else {
                    yearPlan.price = `₹${formatIndianCurrency(
                      price.orginalPrice_INR,
                    )} per Year`;
                    yearPlan.priceInDollars = `₹${formatIndianCurrency(
                      price.orginalPrice_INR,
                    )}`;
                    yearPlan.priceId = price.stripePriceId;
                  }
                }
              });

              let limit = parseInt(
                license.features?.filter(
                  (feature) => feature.type === "NUM_SITES",
                )[0]?.limitOrAvailablity,
              );
              monthPlan.numberOfSites = limit;
              yearPlan.numberOfSites = limit;
              monthPlans.push(monthPlan);
              yearPlans.push(yearPlan);
            }
          });
          let addonsData = [];
          data?.features?.licenses?.map((license) => {
            let addOnDetails = {};
            addOnDetails.name = license.licenseType;
            addOnDetails.price = license.pricing[0].orginalPrice_INR;
            addOnDetails.priceId = license.pricing[0].stripePriceId;
            addOnDetails.billingType = license.pricing[0].billingType;
            addonsData.push(addOnDetails);
          });
        },
      },
    });
  }, []);

  const handleStripeSubscription = (isUpdate, expiryDate = null) => {
    const commonData = {
      orgId: orgId,
      priceId: matchingBillingData?.stripePriceId,
    };

    if (expiryDate && isUpdate) {
      commonData.expiryDate = expiryDate;
    }

    const actionType = isUpdate
      ? Actions.GET_STRIPE_UPDATE_SUBSCRIPTION
      : Actions.GET_STRIPE_CREATE_SUBSCRIPTION;

    const actionData = isUpdate
      ? commonData
      : { ...commonData, couponId: coupon };

    getStore().dispatch({
      type: actionType,
      data: actionData,
      meta: {
        onSuccess: isUpdate
          ? async (dataArray) => {
              for (let i = 0; i < dataArray.length; i++) {
                if (dataArray[i]?.clientSecret) {
                  await stripe?.confirmCardPayment(dataArray[i].clientSecret);
                }
              }
              upgradePopup();
              setIsLoading(false);
              setIsPaneOpen(false);
            }
          : (data) => {
              setIsLoading(false);
              let newLink = data?.link;

              if (typeof newLink === "string") {
                window.open(newLink, "_blank");
              }
              getStore().dispatch({
                type: Actions.SET_PLAN,
                data: {
                  plan: true,
                },
              });
              navigate(`/account/${orgId ? orgId : -1}/dashboard`);
            },
        onError: isUpdate
          ? () => {
              upgradeFailPopup();
              setIsLoading(false);
              setIsPaneOpen(false);
            }
          : () => {
              setIsLoading(false);
            },
      },
    });
  };

  const handleCashfreeSubscription = (isUpdate, expiryDate = null) => {
    const commonData = {
      newPlanName: matchingBillingData?.stripePriceId,
      orgId: orgId,
    };

    if (expiryDate) {
      commonData.expiryDate = expiryDate;
    }

    const actionType = isUpdate
      ? Actions.GET_CASHFREE_UPDATE_SUBSCRIPTION
      : Actions.GET_CASHFREE_CREATE_SUBSCRIPTION;

    const actionData = isUpdate
      ? commonData
      : { ...commonData, coupon: coupon };

    getStore().dispatch({
      type: actionType,
      data: actionData,
      meta: {
        onSuccess: isUpdate
          ? (data) => {
              if (data === null) {
                downgradePopup();
                setIsPaneOpen(false);
              } else {
                const cleanedData = data.replace(/\\/g, "");
                cashfreeSubscriptionSessionIdDecrypt(cleanedData);
                setIsLoading(false);
                navigate(`/account/${orgId ? orgId : -1}/dashboard`);
              }
            }
          : (data) => {
              const cleanedData = data.replace(/\\/g, "");
              cashfreeSubscriptionSessionIdDecrypt(cleanedData);
              setIsLoading(false);
              navigate(`/account/${orgId ? orgId : -1}/dashboard`);
            },
        onError: isUpdate
          ? () => {
              noUpgradePopup();
              setIsLoading(false);
              setIsPaneOpen(false);
              navigate(`/account/${orgId ? orgId : "indv"}/dashboard`);
            }
          : () => {
              setIsLoading(false);
            },
      },
    });
  };

  const handleUpdateClick = () => {
    const basePlan = specificPlan?.find((item) => item.basePlan === true);

    if (
      specificPlan?.length > 0 &&
      basePlan &&
      isSingleSite !== basePlan?.isSingleSite
    ) {
      singleSitePopup();
      return;
    }

    setIsLoading(true);
    getStore().dispatch({
      type: Actions.API_FETCH_STATUS,
      data: {
        orgId: orgId,
        basePlan: true,
        addon: false,
      },
      meta: {
        onSuccess: (fetchStatus) => {
          if (fetchStatus) {
            if (country === "USA") {
              buyNowUSD(specificPlan?.length);
            } else {
              buyNowCashfree(specificPlan?.length);
            }
          } else {
            waitPlanPopup();
            setIsLoading(false);
            setIsPaneOpen(false);
          }
        },
        onError: () => {
          waitPlanPopup();
          setIsLoading(false);
          setIsPaneOpen(false);
        },
      },
    });
  };

  function buyNowUSD(length) {
    setIsLoading(true);
    const basePlan = specificPlan.find((item) => item.basePlan === true);

    const isSamePlanType =
      matchingBillingData?.billingType === basePlan?.billingType &&
      matchingBillingData?.licenseType === basePlan?.licenseType;

    const isUpgrade =
      Number(matchingBillingData?.originalPrice) >
      Number(basePlan?.salePriceUS);

    if (length > 0) {
      if (isSamePlanType) {
        const isExpired = basePlan?.daysAfterExpiry > 0;
        const expiryDate = isExpired ? basePlan?.expirationDate : null;
        handleStripeSubscription(false, expiryDate);
      } else {
        if (isUpgrade) {
          handleStripeSubscription(true);
        } else {
          downgradePopup();
          setIsLoading(false);
          setIsPaneOpen(false);
        }
      }
    } else {
      handleStripeSubscription(false);
    }
  }

  function buyNowCashfree(length) {
    setIsLoading(true);
    let basePlan = specificPlan.find((item) => item.basePlan === true);

    let isSamePlanType =
      matchingBillingData?.billingType === basePlan?.billingType &&
      matchingBillingData?.licenseType === basePlan?.licenseType;

    let isUpgrade =
      Number(matchingBillingData?.orginalPrice_INR) >
      Number(basePlan?.originalPriceInr);

    if (length > 0) {
      if (isSamePlanType) {
        const isExpired = basePlan?.daysAfterExpiry > 0;
        const expiryDate = isExpired ? basePlan?.expirationDate : null;
        handleCashfreeSubscription(true, expiryDate);
      } else {
        if (isUpgrade) {
          handleCashfreeSubscription(true);
        } else {
          downgradePopup();
          setIsLoading(false);
          setIsPaneOpen(false);
        }
      }
    } else {
      handleCashfreeSubscription(false);
    }
  }

  const formattedDate = (() => {
    const currentDate = new Date();
    const nextChargeDate = new Date(currentDate);
    if (billingType === "Monthly") {
      nextChargeDate.setMonth(nextChargeDate.getMonth() + 1);
    } else if (billingType === "Yearly") {
      nextChargeDate.setFullYear(nextChargeDate.getFullYear() + 1);
    }
    return nextChargeDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  })();

  return (
    <>
      <NewPopup
        trigger={isPaneOpen}
        header="Plan Summary"
        customWidth={"30%"}
        closePopup={() => {
          flushStateVariables();
        }}
        backPopup="Cancel"
        backOnClick={() => {
          flushStateVariables();
        }}
        nextpopup={"Continue"}
        nextOnClick={() => {
          if (
            country === "India" &&
            isProcessingCashfree?.paymentProcess === true
          ) {
            setShowPopup(true);
          }
          if (country === "India" && specificPlan?.length === 0) {
            setIsIndPayment(true);
          } else {
            handleUpdateClick();
          }
        }}
        loading={isLoading || isSummaryLoading}
        disabled={!isData}
      >
        <>
          {isSummaryLoading ? (
            <Grid2 className={BillingStyle.isSummaryLoadingHeight}>
              <CircularProgress size={28} />
            </Grid2>
          ) : (
            <>
              <Grid2 className={BillingStyle.height}>
                <Grid2 className={BillingStyle.container}>
                  <Grid2 className={BillingStyle.headerContainer}>
                    <Grid2 className={BillingStyle.planHeader}>
                      <Grid2 className={BillingStyle.planLabelRow}>
                        <Grid2 className={BillingStyle.planLabel}>
                          {isSingleSite ? "SS" : "MS"} -{" "}
                          {matchingBillingData?.licenseType}
                        </Grid2>
                        <Grid2 className={BillingStyle.planTypeLabel}>
                          {billingType === "Monthly"
                            ? "(Monthly Plan)"
                            : "(Yearly Plan)"}
                        </Grid2>
                      </Grid2>
                      <Grid2 className={BillingStyle.priceHeader}>
                        <Grid2 className={BillingStyle.planLabel}>
                          {country === "India" ? `₹` : `$`}
                          {formatIndianCurrency(
                            Number(isData?.yearlyPrice).toFixed(2),
                          )}
                          /
                        </Grid2>
                        <Grid2 className={BillingStyle.planTypeLabel}>
                          {billingType === "Monthly" ? "mon" : "yr"}
                        </Grid2>
                      </Grid2>
                    </Grid2>
                    <Grid2 className={BillingStyle.planHeader}>
                      <Grid2 className={BillingStyle.planTypeLabel}>
                        {numSites} Sites
                      </Grid2>
                      <Grid2 className={BillingStyle.dateFormat}>
                        Next Bill {"  "}
                        {formattedDate}
                      </Grid2>
                    </Grid2>
                  </Grid2>

                  <Grid2 className={BillingStyle.noLineBlack} />
                  {specificPlan?.length === 0 && (
                    <Grid2 className={BillingStyle.couponBtn}>
                      <CouponCode
                        plan={specificPlan}
                        onApplyCoupon={handleClick}
                        coupon={coupon}
                        setCoupon={setCoupon}
                        isCouponLoading={isCouponLoading}
                        validCoupon={isData?.couponDiscountResponse}
                        setValidCoupon={setIsData}
                        showInput={showInput}
                        setShowInput={setShowInput}
                      />
                    </Grid2>
                  )}
                  {/* Coupon Discount Calculation */}
                  {isData?.couponDiscountResponse?.validity === true && (
                    <Grid2 className={BillingStyle.couponContainer}>
                      <Grid2>
                        <Grid2 className={BillingStyle.planHeader}>
                          <Grid2 className={BillingStyle.planLabel1}>
                            Coupon Discount
                          </Grid2>
                          <Grid2 className={BillingStyle.priceHeader}>
                            <Grid2 className={BillingStyle.planLabel1}>
                              <RemoveIcon className={BillingStyle.planLabel1} />
                              {country === "India" ? "₹" : "$"}
                              {formatIndianCurrency(
                                Number(
                                  isData?.couponDiscountResponse?.amountOff,
                                ).toFixed(2),
                              )}
                              /
                            </Grid2>
                            <Grid2 className={BillingStyle.planTypeLabel}>
                              {billingType === "Monthly" ? "mon" : "yr"}
                            </Grid2>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  )}

                  {/* Platform Discount Calculation */}
                  {billingType === "Yearly" && (
                    <Grid2 className={BillingStyle.couponContainer}>
                      <Grid2>
                        <Grid2 className={BillingStyle.planHeader}>
                          <Grid2 className={BillingStyle.planLabel1}>
                            Platform Discount
                          </Grid2>
                          <Grid2 className={BillingStyle.priceHeader}>
                            <Grid2 className={BillingStyle.planLabel1}>
                              <RemoveIcon className={BillingStyle.planLabel1} />
                              {country === "India" ? "₹" : "$"}
                              {formatIndianCurrency(isData?.platformDisc)}/
                            </Grid2>
                            <Grid2 className={BillingStyle.planTypeLabel}>
                              {billingType === "Monthly" ? "mon" : "yr"}
                            </Grid2>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  )}

                  {/* SubTotal Calculation */}
                  {country === "India" && specificPlan?.length === 0 && (
                    <>
                      <Grid2 className={BillingStyle.noLineBlack} />
                      <Grid2 className={BillingStyle.planHeader}>
                        <Grid2 className={BillingStyle.planLabel}>
                          Sub Total
                        </Grid2>
                        <Grid2 className={BillingStyle.priceHeader}>
                          <Grid2 className={BillingStyle.planLabel}>
                            {country === "India" ? "₹" : "$"}
                            {formatIndianCurrency(isData?.subTotal)}/
                          </Grid2>
                          <Grid2 className={BillingStyle.planTypeLabel}>
                            {billingType === "Monthly" ? "mon" : "yr"}
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </>
                  )}

                  {/* GST Calculation */}
                  {country === "India" && (
                    <Grid2 className={BillingStyle.planHeader}>
                      <Grid2 className={BillingStyle.planLabel1}>
                        GST (18%)
                      </Grid2>
                      <Grid2 className={BillingStyle.priceHeader}>
                        <Grid2 className={BillingStyle.planLabel1}>
                          {country === "India" ? "₹" : "$"}
                          {formatIndianCurrency(
                            Number(isData?.gstAmount).toFixed(2),
                          )}
                          /
                        </Grid2>
                        <Grid2 className={BillingStyle.planTypeLabel}>
                          {billingType === "Monthly" ? "mon" : "yr"}
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  )}

                  {specificPlan?.length === 0 && (
                    <Grid2 className={BillingStyle.noLineBlack} />
                  )}

                  {/* Total Calculation */}
                  <Grid2 className={BillingStyle.planHeader}>
                    <Grid2 className={BillingStyle.planTotalLabel}>Total</Grid2>
                    <Grid2 className={BillingStyle.priceHeader}>
                      <Grid2 className={BillingStyle.planTotalLabel}>
                        {country === "India" ? "₹" : "$"}
                        {formatIndianCurrency(
                          Number(isData?.totalAmount).toFixed(2),
                        )}
                        /
                      </Grid2>
                      <Grid2 className={BillingStyle.planTypeLabel}>
                        {billingType === "Monthly" ? "mon" : "yr"}
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2 className={BillingStyle.container}>
                {country === "USA" ? (
                  <Grid2 className={BillingStyle.planTypeLabel}>
                    Your order may attract local taxes according to the billing
                    information you give. The total cost might be different from
                    the amount indicated here and will appear on your checkout.
                  </Grid2>
                ) : (
                  <Grid2 className={BillingStyle.planTypeLabel}>
                    Displayed amount at checkout may reflects the amount for
                    your next billing cycle. However, you will only be charged
                    the amount shown above within the next 48 hrs. You may
                    cancel your plan at any time.
                  </Grid2>
                )}
              </Grid2>
            </>
          )}
        </>
      </NewPopup>

      <ModalPopup
        trigger={showPopup}
        closePopup={() => setShowPopup(false)}
        header={"Payment Process...."}
        customWidth="750px"
        nextpopup={"Proceed ahead"}
        nextOnClick={() => {
          setShowPopup(false);
        }}
        backPopup={"Cancel"}
        backOnClick={() => {
          setShowPopup(false);
        }}
      >
        <PaymentStatus
          isProcessingCashfree={isProcessingCashfree}
          setShowPopup={setShowPopup}
          isProcessing={isProcessing}
        />
      </ModalPopup>
    </>
  );
};

export default BasePlanBillingSummary;
